import _ from 'underscore';
import ko from 'knockout';

export class BaseLocationRecommendationModel {
  constructor({
    deps,
  }) {
    this.locationRecommendations = ko.observable([]);
    this.locationImpressionGain = ko.computed(() =>
      _.reduce(
        this.locationRecommendations(),
        (ret, { EstimatedIncreaseInImpressions }) => ret + EstimatedIncreaseInImpressions,
        0
      ));
    this.locationTrafficGain = ko.computed(() => {
      const idList = [];
      const { QueriesFiltered, QueriesPassedLocationFiltering } =
        _.reduce(this.locationRecommendations(), (ret, recommend) => {
          const campaignId = _.chain(ret).result('Campaign').result('Id').value();
          let passedFiltering = 0;
          if (!_.contains(idList, campaignId)) {
            idList.push(campaignId);
            passedFiltering = recommend.QueriesPassedLocationFiltering;
          }
          return {
            QueriesFiltered: ret.QueriesFiltered + recommend.QueriesFiltered,
            QueriesPassedLocationFiltering:
              ret.QueriesPassedLocationFiltering + passedFiltering,
          };
        }, { QueriesFiltered: 0, QueriesPassedLocationFiltering: 0 });

      const totalTraffic = QueriesPassedLocationFiltering;
      if (totalTraffic === 0) {
        return 0;
      }
      return deps.i18n.formatPercentToFixed(QueriesFiltered / totalTraffic);
    });
  }
}
